import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { ISpinnerState, SpinnerService } from './spinner.service';

@Component({
    selector: 'flo-spinner-component',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.scss'],
})

export class SpinnerComponent implements OnDestroy, OnInit {
    public show: boolean = false;
    public message: string = null;

    private spinnerStateChanged: Subscription;

    constructor(
        private spinnerService: SpinnerService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    public ngOnInit(): void {
        this.spinnerStateChanged = this.spinnerService.spinnerSubject
            .subscribe((state: ISpinnerState) => {
                this.show = state.show;
                this.changeDetectorRef.detectChanges();
            });

        this.spinnerStateChanged = this.spinnerService.spinnerMessageSubject
            .subscribe((message: string) => {
                this.message = message;
            });
    }

    public ngOnDestroy(): void {
        this.spinnerStateChanged.unsubscribe();
    }
}
